export function impactLevelSortBuilder(direction) {
  function convertImpactLevelToNumber(impactLevel) {
    switch (impactLevel) {
      case "High":
        return 1;
      case "Moderate":
        return 2;
      case "LI-SaaS":
        return 3;
      case "Low":
        return 4;
      default:
        return 5;
    }
  }

  return (fedRampProduct1, fedRampProduct2) => {
    const impactLevel1 = convertImpactLevelToNumber(fedRampProduct1.impactLevel);
    const impactLevel2 = convertImpactLevelToNumber(fedRampProduct2.impactLevel);
    if (impactLevel1 === impactLevel2) {
      return 0;
    } else if (impactLevel1 < impactLevel2) {
      return direction === "asc" ? -1 : 1;
    } else {
      return direction === "asc" ? 1 : -1;
    }
  };
}

export function providerSortBuilder(direction) {
  function calculateReturn(provider1, provider2) {
    if (direction === "asc") {
      if (provider1.toLowerCase() < provider2.toLowerCase()) {
        return -1;
      } else if (provider1.toLowerCase() > provider2.toLowerCase()) {
        return 1;
      } else {
        return 0;
      }
    } else {
      if (provider1.toLowerCase() < provider2.toLowerCase()) {
        return 1;
      } else if (provider1.toLowerCase() > provider2.toLowerCase()) {
        return -1;
      } else {
        return 0;
      }
    }
  }

  return (fedRampProduct1, fedRampProduct2) => {
    if (fedRampProduct1.missingProvider) {
      if (fedRampProduct2.missingProvider) {
        return calculateReturn(fedRampProduct1.missingProvider, fedRampProduct2.missingProvider);
      } else {
        return calculateReturn(fedRampProduct1.missingProvider, fedRampProduct2.provider);
      }
    } else if (fedRampProduct2.missingProvider) {
      return calculateReturn(fedRampProduct1.provider, fedRampProduct2.missingProvider);
    } else {
      return calculateReturn(fedRampProduct1.provider, fedRampProduct2.provider);
    }
  };
}